import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

import ApplicationSentView from './ApplicationSentView';
import ApplicationSentOtherCityView from './ApplicationSentView/ApplicationSentOtherCityView';
import ApplicationSentSSMOView from './ApplicationSentView/ApplicationSentSSMOView';
import ComplianceFooter from './ComplianceFooter';
import SelfServeFormView from './SelfServeFormView/SelfServeFormView';
import InboundFormHeader from './common/SimpleHeader';
import { MOBILE_BREAKPOINT, useIsMobile } from '../../common/hooks/useIsMobile';

const Root = styled.div<{ isMobile: boolean }>`
  display: flex;
  position: relative;
  flex: 1 1 auto;
  flex-direction: column;
  background-position: bottom left;
  background-repeat: no-repeat;
  overflow: ${({ isMobile }) => (isMobile ? 'unset' : 'hidden')};
  /* TODO this looks broken - won't this be
      "padding-block-end: padding-block-end: min(40vw, 312px)" when interpreted to CSS? */
  padding-block-end: ${({ isMobile }) =>
    isMobile ? 'padding-block-end: min(40vw, 312px)' : 'padding-block-end: max(32px, 7vw)'};
  background-size: ${({ isMobile }) => (isMobile ? 'auto min(40vw, 312px)' : '380px auto')};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 480px;
  margin-inline-end: 48px;
  margin-inline-start: 55vw;
  overflow: auto;
  scrollbar-width: none;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    margin: 16px;
    padding-block-start: 210px;
  }
`;

const Heading = styled(T.Heading1)`
  margin-block-end: 48px;
  max-width: 600px;
  font-weight: 700;
  font-size: 64px;
  line-height: 68px;
  color: ${cbSemanticCssVars.textPrimary};

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 48px;
    margin-block-end: 32px;
  }
`;

const UpHeading = styled(T.Heading4)`
  margin-block-end: 16px;
  color: ${cbSemanticCssVars.textSecondary};

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 20px;
    margin-block-end: 8px;
  }
`;

const Wrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  padding: 24px;
  align-items: center;
  border-radius: 16px;
  border: 1px solid ${cbSemanticCssVars.borderPrimary};
  background-color: ${cbSemanticCssVars.surfaceMain};
  max-width: 480px;
  margin-block-end: ${({ isMobile }) => (isMobile ? '48px' : '104px')};
`;

const MerchantHeroImage = styled.img`
  object-fit: cover;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    height: 300px;
  }
`;

const SelfServeSignUp = () => {
  const { url } = useRouteMatch();
  const isMobile = useIsMobile();
  const history = useHistory();

  const backgroundSrc = isMobile
    ? `${process.env.CDN_URL}/onboarding/ssmo/merchant-hero.png`
    : ` ${process.env.CDN_URL}/onboarding/ssmo/merchant-hero@2x.png`;

  return (
    <Root isMobile={isMobile}>
      <InboundFormHeader />
      <MerchantHeroImage src={backgroundSrc} />
      <Content>
        <UpHeading>
          <FormattedMessage id="self-serve-sign-up.upheader-text" />
        </UpHeading>
        <Heading>
          <FormattedMessage id="self-serve-sign-up.header-text" />
        </Heading>
        <Wrapper isMobile={isMobile}>
          <Switch>
            <Route exact path={url}>
              <SelfServeFormView onSuccess={(redirect: string) => history.push(`${url}/${redirect}`)} />
            </Route>
            <Route exact path={`${url}/application-sent`} component={ApplicationSentView} />
            <Route exact path={`${url}/application-sent-ssmo`} component={ApplicationSentSSMOView} />
            <Route exact path={`${url}/application-sent-other-city`} component={ApplicationSentOtherCityView} />
          </Switch>
        </Wrapper>
      </Content>
      <ComplianceFooter isMobile={isMobile} sticky showContactUs />
    </Root>
  );
};

export default SelfServeSignUp;
